__turbopack_context__.v({
  "container": "LayoutStack-module__iW_hvW__container",
  "flex": "LayoutStack-module__iW_hvW__flex",
  "stack": "LayoutStack-module__iW_hvW__stack",
});
